import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, TextField, Toolbar, Typography } from "@material-ui/core";
import ConfirmacaoApp from "app/Core/Components/Confirmacao/ConfirmacaoApp";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/GerenciadorProcessoActions";

const md = new MobileDetect(window.navigator.userAgent);

const NewState = {
    observacao: null,
    prazo: null,
    termino: null,
    data: null,
    horario: null,
};

class GerenciadorProcessoDialog extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        this.setState(NewState);
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    canBeSubmitted = () => {
        const { open } = this.props;
        const { observacao } = this.state;
        return ((open.proximopasso === 666 &&
            observacao !== null &&
            observacao !== "" &&
            observacao.length > 5) || open.proximopasso !== 666);
    };

    handleChangeByFormulario = (_AForm) => {
        var obj = JSON.parse(JSON.stringify(this.state));
        Object.keys(_AForm).forEach(key => {
            obj[key] = _AForm[key];
        });
        this.setState(obj);
    };

    render() {
        const { open, openDialog, Tarefa, fireAction, xappRouteParams } = this.props;
        const form = this.state;

        return (
            <XAPPDialog
                id="GerenciadorProcesso"
                classes={{
                    paper: "m-24"
                }}
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                maxWidth="sm"
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {"Confirmar"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="Close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                {!_.isNull(open) &&
                    <DialogContent>
                        <div className="flex w-full pt-24">
                            {open.proximopasso === 666 &&
                                <TextField
                                    className="w-full"
                                    label={"Motivo"}
                                    id="observacao"
                                    name="observacao"
                                    value={form.observacao}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    multiline
                                    rows={5}
                                />
                            }
                        </div>
                    </DialogContent>
                }
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0 px-8">
                        <DialogActions>
                            {open !== null &&
                                <ConfirmacaoApp
                                    id="ConfirmacaoAcao"
                                    data="ConfirmacaoAcao"
                                    type="button"
                                    onConfirmation={() => {
                                        fireAction(open, this.props, form);
                                        openDialog(null);
                                    }}
                                    mensagem={"Tem certeza que deseja executar a ação \"" + open.nome + "\"?"}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"done"}
                                    label={md.mobile() === null && md.tablet() === null ? "Confirmar" : ""}
                                    className={"bg-green hover:bg-green text-white mr-8 min-w-60 px-6 py-14"}
                                    disabled={!this.canBeSubmitted()}
                                />
                            }
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        acao: Actions.acao,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ GerenciadorProcessoApp, auth }) {
    return {
        reducer: GerenciadorProcessoApp,
        user: auth.user.data
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(GerenciadorProcessoDialog);
